export default __webpack_public_path__ + "static/media/DSC_7429.c8a6df17.jpg";